// Time slot definition. Hours with half-hour split: 6..17, 22, 23（14 小时 × 2 = 28 格）。
// 整点格小时: 0-5, 18-21（10 小时 × 1）。Total = 38。
// N36（2026-06-03）: 6 点拆半点（夏天 6:30 起床）SLOT_COUNT 35→36。
// N58（2026-06-18）: 22/23 点拆半点（晚间细分）SLOT_COUNT 36→38。
// 旧数据由 app.jsx loadState() 一次性迁移（35→36→38 链式，带逃生备份、幂等）。
// 导出供 io/xlsx 复用，避免两处 half-hour 集合漂移。
export const HALF_HOUR_HOURS = new Set([6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 22, 23]);

function pad(n) { return String(n).padStart(2, '0'); }

function buildSlots() {
  const slots = [];
  for (let h = 0; h < 24; h++) {
    if (HALF_HOUR_HOURS.has(h)) {
      slots.push({ h, m: 0, label: `${pad(h)}:00`, span: 0.5 });
      slots.push({ h, m: 30, label: `${pad(h)}:30`, span: 0.5 });
    } else {
      slots.push({ h, m: 0, label: `${pad(h)}:00`, span: 1 });
    }
  }
  return slots;
}

export const SLOTS = buildSlots();
export const SLOT_COUNT = SLOTS.length;

// Build initial empty day: 3 tracks × SLOT_COUNT cells.
// track 0 = eat/fun, track 1 = sleep, track 2 = exercise (per spec)
// 结构化深比较：day 是否在所有字段上都等于 emptyDay()。
// 设计原则：err on the side of preservation —— 任何结构不一致 / 多出字段 / 类型异常都视为"有数据，保留"。
export function isEmptyDay(day) {
  if (!day) return true;
  const def = emptyDay(day.date || '');
  return deepEqualSkipDate(day, def, true);
}

function deepEqualSkipDate(a, b, isTopLevel) {
  if (a === b) return true;
  if (a == null && b == null) return true;
  if (a == null || b == null) return false;
  if (typeof a !== typeof b) return false;
  if (Array.isArray(a) !== Array.isArray(b)) return false;
  if (Array.isArray(a)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (!deepEqualSkipDate(a[i], b[i], false)) return false;
    }
    return true;
  }
  if (typeof a === 'object') {
    const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
    for (const k of keys) {
      if (isTopLevel && k === 'date') continue;
      if (!deepEqualSkipDate(a[k], b[k], false)) return false;
    }
    return true;
  }
  return false;
}

export function emptyDay(date) {
  return {
    date,
    meals: { breakfast: null, lunch: null, dinner: null },
    sleepHours: null,
    napHours: null,
    sleepDuration: null,
    boneMass: null,
    weight: null,
    mainEvent: '',
    emotions: [],
    exerciseTypes: [],
    efficiency: null,
    nightWake: 0,
    phoneBeforeSleep: false,
    listenBeforeSleep: false,
    tracks: [
      new Array(SLOT_COUNT).fill(null),
      new Array(SLOT_COUNT).fill(null),
      new Array(SLOT_COUNT).fill(null),
    ],
    merges: [],
    notes: {},
    noteAligns: {},
    noteTruncates: {},
    pomoLogs: [],
    photo: null,
    photoCaption: '',
    photoLocation: '',
    photoGeo: null,
    photoTakenAt: null,
    cycle: null,
    cycleDay: null,
    bloodFlow: 0,
    cramps: 0,
    cycleSymptoms: [],
  };
}

// Date helpers
export function dateKey(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function parseDate(k) {
  const [y, m, d] = k.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function addDays(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}
